import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateTime'
})
export class DateTimePipe implements PipeTransform {

  transform(value, type) {
    if (!value) return;
    const pipe = new DatePipe('en-US');
    if(value.includes(' ')){
      value = value.replace(' ','T');
      value = value + 'Z';
    }
    let format;
    if (type == 'hypenDate') {
      format = pipe.transform(value, 'dd-MM-yyyy');
    } else if (type == 'dateTime') {
      const date = pipe.transform(value, 'dd MMM yyyy');
      const time = pipe.transform(value, 'hh:mm a');
      format = `${date} | ${time}`;
    } else if (type == 'date') {
      format = pipe.transform(value, 'dd MMM yyyy');
    } else {
      return;
    }
    return format;
  }

}
